import { useState } from "react";

const LearnToPlayBlock = ({ data }) => {
  const { title, videoUrl, textVersion } = data;


  const [isTextVisible, setIsTextVisible] = useState(false);

  const isTextVersionEmpty = () => {
    if (textVersion.title.trim() || textVersion.descr.trim()) {
      return false;
    }

    for (const step of textVersion.steps) {
      if (step.stepTitle.trim() || step.stepsList.length > 0) {
        return false;
      }
    }

    if (textVersion.finalText.trim()) {
      return false;
    }

    return true;
  };

  return (
    <section className="privacy-page__block">
      <h2 className="privacy-page__block-title">{title}</h2>
      <div className="privacy-page__video-wrapper">
        <iframe
          title="YouTube video player"
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
          className="privacy-page__video-iframe"
        />
      </div>
      {isTextVersionEmpty() === false && (
        <>
          <button
            className={`privacy-page__show-more ${
              isTextVisible ? "active" : ""
            }`}
            onClick={() => setIsTextVisible(!isTextVisible)}
          >
            {isTextVisible ? "Hide" : "Show"} text version
          </button>

          {isTextVisible && (
            <>
              <section className="privacy-page__block privacy-page__head">
                <h2 className="privacy-page__block-title">
                  How to Purchase Card Packs for Identities and Predictions
                </h2>
                <p className="privacy-page__block-descr">
                  In this guide, you'll learn the steps to purchase card packs,
                  which are essential for creating identities and making
                  predictions.
                </p>
              </section>
              <section className="privacy-page__block">
                <h2 className="privacy-page__block-title">
                  Step 1: Access the Buy Packs Section
                </h2>
                <ul className="privacy-page__block-list">
                  <li className="privacy-page__block-list-item">
                    From your dashboard, locate and click on Buy Packs in the
                    main navigation bar.
                  </li>
                </ul>
              </section>
              <section className="privacy-page__block">
                <h2 className="privacy-page__block-title">
                  Step 2: Understand Pack Collections
                </h2>
                <ul className="privacy-page__block-list">
                  <li className="privacy-page__block-list-item">
                    Packs are organized by collection, each with a specific
                    theme and type.
                  </li>
                  <li className="privacy-page__block-list-item">
                    For example, the theme of one collection is 2025 PGA Players
                    and the type is Identity.
                  </li>
                  <li className="privacy-page__block-list-item">
                    The price of this pack is $2.
                  </li>
                </ul>
              </section>
              <section className="privacy-page__block">
                <h2 className="privacy-page__block-title">
                  Step 3: Purchase a Single Pack
                </h2>
                <ul className="privacy-page__block-list">
                  <li className="privacy-page__block-list-item">
                    To buy a single pack, click the Buy Now button.
                  </li>
                  <li className="privacy-page__block-list-item">
                    Review the card details section to see pack properties, the
                    number of cards, and the multi-pack purchase widget.
                  </li>
                </ul>
              </section>
              <section className="privacy-page__block">
                <h2 className="privacy-page__block-title">
                  Step 4: Explore Prediction Pack Collection
                </h2>
                <ul className="privacy-page__block-list">
                  <li className="privacy-page__block-list-item">
                    This collection contains packs for making predictions with
                    the identities you create.
                  </li>
                  <li className="privacy-page__block-list-item">
                    These packs also include valuable prize cards.
                  </li>
                  <li className="privacy-page__block-list-item">
                    Click Buy Now to purchase a single pack.
                  </li>
                </ul>
              </section>
              <section className="privacy-page__block">
                <h2 className="privacy-page__block-title">
                  Step 5: Select Payment Method
                </h2>
                <ul className="privacy-page__block-list">
                  <li className="privacy-page__block-list-item">
                    Choose your preferred payment method and click the
                    confirmation buttons.
                  </li>
                </ul>
              </section>
              <section className="privacy-page__block">
                <h2 className="privacy-page__block-title">
                  Step 6: Purchase Multiple Packs
                </h2>
                <ul className="privacy-page__block-list">
                  <li className="privacy-page__block-list-item">
                    Select the pack you want to buy multiple of.
                  </li>
                  <li className="privacy-page__block-list-item">
                    Enter the desired quantity in the multi-pack purchase
                    section and click Buy Now.
                  </li>
                  <li className="privacy-page__block-list-item">
                    Select your payment method again.
                  </li>
                </ul>
              </section>
              <section className="privacy-page__block">
                <h2 className="privacy-page__block-title">
                  Step 7: Review Your Purchases
                </h2>
                <ul className="privacy-page__block-list">
                  <li className="privacy-page__block-list-item">
                    Click on Card Packs to view your purchased packs.
                  </li>
                </ul>
              </section>
              <p className="privacy-page__block-descr">{textVersion.finalText}</p>
            </>
          )}
        </>
      )}
    </section>
  );
};

export default LearnToPlayBlock;
